import { Component, NgZone, OnInit, ViewChild, NgModule } from "@angular/core";
import { RemoteApiService } from "./servise/remote-api.service";
import { environment } from "src/environments/environment";
import { SnotifyService, ToastDefaults } from "ng-snotify";
import { TaxDetails } from "./model/common";
import { User } from "./model/common";
import { MatStepper } from "@angular/material/stepper";
import Swal from "sweetalert2";
import { ExternalLibraryService } from "./razorpay";
import { MatTabsModule, MatDialog, MatDialogRef, MatTabChangeEvent, MatDialogConfig } from '@angular/material';
import { SubscriptionHistoryComponent } from '../subscription-history/subscription-history.component';
import { ChannelListComponent } from '../channel-list/channel-list.component';
import { empty } from 'rxjs';
import { FormControl } from '@angular/forms';
import { NgForOf } from '@angular/common';
declare let Razorpay: any;
@Component({
  selector: "app-payment",
  templateUrl: "./payment.component.html",
  styleUrls: ["./payment.component.scss"],
})
@NgModule({
  declarations:[SubscriptionHistoryComponent]
})
export class PaymentComponent implements OnInit {
  API = {
    VALIDATE_SUBSCRIBER_ID: "validateSubscriberId",
    SUBSCRIPYION_DETAIL: "getSubscriptionPlanDetails",
    VALIDATE_PACKAGE_DETAILS: "validatePackageDetails",
    CREATE_RAZOR_PAY_ORDER: "createBSNLOrderDevice",
    VALIDATE_RAZORPAY: "validateBSNLPayment",
    GET_PLAN_DETAILS :"user_details_request",
    // VERIFY_OTP:"otp",
    VERIFY_OTP:"verifyOtp",
    SEND_OTP:"sendOTPtoMobileNumber",
    GET_USER_SUBSCRIPTION_DETAILS : "subscriptiondetails",
    };

  @ViewChild("stepper", { static: true }) stepper: MatStepper;
  subscriberId: any;
  firstName: any;
  userId: any;
  taxDetails: any;
  subscriptionPlanDetails: any = {};
  selectedPackageType: any;
  selectedPackage: any;
  selectedDevice: any;
  Object = Object;
  packageList: any = [];
  deviceList: any = [];
  cartList: any = [];
  loaderShow: boolean = false;
  totalAmount: any = 0;
  grandTotalAmount: any = 0;
  totalTaxPer: any = 0;
  math = Math;
  razorpaykey = environment.razorpaykey;
  basicId: any;
  taxPrice: any;
  basicIdValidate: any;
  payperviewValidate: any;
  valid=false;
  otp:any;
  subscriptionHistory : any = [] ;
  subscriptionActive : any = [];
  subscriptionPrebook : any = [] ;
  activesubscription : any;
  prebooksubscription : any;
  subscriptionhistory : any;
  flag :any;
  packageId:any;
  periodList:any[];
  selectedPeriod: any;
  subscriberDeviceList : any =[];
  selectedDeviceList : any;
  ppvDetails:any;
  packDetails :any;
  ftaAdded=false;
  verifiedOnce:any;



  RAZORPAY_OPTIONS = {
    key: this.razorpaykey,
    amount: "",
    name: "",
    order_id: "",
    description: "",
    image: "../../assets/images/bsnl.min.png",
    prefill: {
      name: "",
      email: "",
      contact: "",
      method: "",
    },
    modal: {},
    theme: {
      color: "#0f79af",
    },
  };


  constructor(
    private remoteapi: RemoteApiService,
    private notify: SnotifyService,
    private razorpayService: ExternalLibraryService,
    private ngZone: NgZone,
    public dialog: MatDialog
  ) {
    notify.config = ToastDefaults;
  }

  ngOnInit() {
    this.flag=1
    // this.razorpayService
    //   .lazyLoadLibrary("https://checkout.razorpay.com/v1/checkout.js")
    //   .subscribe();
  }
  loaderShowHide(val: boolean) {
    this.loaderShow = val;
  }

  getUserDetail() {
    if (this.subscriberId) {
      this.loaderShowHide(true);
      let data = {
        customerId: this.subscriberId.trim(),
      };
      this.remoteapi
        .postExecuteAPI(
          2,
          environment.apiUrl + this.API.VALIDATE_SUBSCRIBER_ID,
          data
        )
        .subscribe((res) => {
          this.loaderShowHide(false);
          if (res.responseCode == "SC101") {
            this.firstName = res.response.firstName;
            this.userId = res.response.userId;
            this.taxDetails = res.response.taxDetails;
            this.totalTaxPer = 0;
            this.taxDetails.forEach((element) => {
              this.totalTaxPer = this.totalTaxPer + element.percentage;
            });
            this.getPackageDetails();
            this.stepper.next();
          } else if (res.responseCode == "FC101") {
            this.notify.clear();
            this.notify.error(res.responseMessage);
          } else {
            this.notify.clear();
            this.notify.error("Something went wrong");
          }
        });
    } else {
      this.notify.clear();
      this.notify.error("Please enter subscriber Id");
    }
  }

  getPackageDetails() {
    let data = {
      appUserId: this.userId,
    };
    this.loaderShowHide(true);
    this.remoteapi
      .postURLEncodedExecuteAPI(
        environment.apiUrl + this.API.SUBSCRIPYION_DETAIL,
        data
      )
      .subscribe((res) => {
        this.loaderShowHide(false);
        if (res.responseCode == "SC101") {
          this.subscriptionPlanDetails = res.subscriptionPlanDetails;
          this.periodList= res.periodList;
          this.subscriberDeviceList=res.subscriberDeviceList;
        } else {
          this.notify.clear();
          this.notify.error("Something went wrong");
        }
      });
  }
  calculateAmount() {
  //  alert(this.totalTaxPer);
    this.totalAmount = 0.0;
    this.grandTotalAmount = 0.0;
    this.cartList.forEach((element) => {
      this.totalAmount = this.totalAmount + (element.directPrice*element.period);
      element.taxAmount = parseFloat((((this.totalTaxPer*element.directPrice)/100)).toString()).toFixed(2);
      element.totalTax = parseFloat(( element.taxAmount*element.period).toString()).toFixed(2);
    });
    this.taxDetails.forEach((element) => {
      element.taxtot = parseFloat(
        (
          (Number(element.percentage) / 100) *
          Number(this.totalAmount)
        ).toString()
      ).toFixed(2);
    });

    let t = (((parseFloat(this.totalTaxPer)) / 100) );
     let v =t * (parseFloat(this.totalAmount));

    this.grandTotalAmount = this.totalAmount + v;

  }




  addCart() {





    if (
      this.selectedPackageType &&
      this.selectedPackage &&
      this.selectedDevice &&
      this.selectedPeriod
    ) {
      if(this.ftaAdded && this.selectedPackageType=="Basic"){
        this.notify.clear();
        this.notify.error("Basic Package is already in Cart");
      } else {
        if(this.selectedPackageType=="Basic"){
          this.ftaAdded = true;
        }
        let objCart = {};
        objCart["pType"] = this.selectedPackageType;
        objCart["packName"] = this.selectedPackage.packName;
        objCart["deviceCount"] = this.selectedDevice.deviceCount;
        objCart["primaryScreen"] = this.selectedDevice.primaryScreen;
        objCart["secondaryScreen"] = this.selectedDevice.secondaryScreen;
        objCart["directPrice"] = this.selectedDevice.directPrice;
        objCart["mediaId"] = this.selectedPackage.mediaId;
        objCart["packId"] = this.selectedPackage.packId;
        objCart["id"] = this.selectedDevice.id;
        objCart["period"]=this.selectedPeriod;
        objCart["device"] ="";
        objCart["taxAmount"] =0.0;
        objCart["totalTax"] =0.0;
        objCart["deviceIds"]="";
       if(this.selectedDeviceList && this.selectedDeviceList.length > 0){
        this.selectedDeviceList.forEach((element) => {
          objCart["deviceIds"]=objCart["deviceIds"]+","+element.deviceId;
          objCart["device"]=objCart["device"]+","+element.nickName;
        });
       }
       objCart["device"] =objCart["device"].substring(1);
       objCart["deviceIds"]=objCart["deviceIds"].substring(1);

        if (this.cartList.length > 0) {
          if (this.selectedPackageType == "Pay Per View") {
            let filter = this.cartList.filter((element) => {
              return element.mediaId == objCart["mediaId"];
            });
            if (filter.length != 0) {
              this.notify.clear();
              this.notify.error("Selected package is exist in cart.");
            } else {
              this.cartList.push(objCart);
              this.calculateAmount();
            }
          } else {
            let filt = this.cartList.filter((element) => {
              return element.packId == objCart["packId"];
            });

            if (filt.length != 0) {
              this.notify.clear();
              this.notify.error("Selected package is exist in cart.");
            } else {
              this.cartList.push(objCart);
              this.calculateAmount();
            }
          }
        } else {
          this.cartList.push(objCart);
          this.calculateAmount();
        }
      }







    } else {
      this.notify.clear();
      this.notify.error("Please select all package  fields.");
    }
  }
  removeCart(obj) {
    if (obj.pType == "Pay Per View") {
      if (this.cartList.length > 0) {
        let filt = this.cartList.filter((element) => {
          return element.mediaId != obj.mediaId;
        });
        this.cartList = [];
        this.cartList = filt;
        this.calculateAmount();
      }
    } else {
      if(obj.pType=="Basic"){
        this.ftaAdded = false;
      }
      if (this.cartList.length > 0) {
        let filt = this.cartList.filter((element) => {
          return element.packId != obj.packId;
        });
        this.cartList = [];
        this.cartList = filt;
        this.calculateAmount();
      }
    }
  }
  packageTypeChange() {
    this.deviceList = [];
    this.packageList = this.subscriptionPlanDetails[this.selectedPackageType];
  }
  packageChange() {
    this.selectedDevice = "";
    if (this.selectedPackageType == "Pay Per View") {
      this.deviceList = this.selectedPackage.contentPriceDetails;
    } else {
      this.deviceList = this.selectedPackage.devicePriceDetails;
    }
  }

  validateBeforePayment() {
    this.loaderShowHide(true);
    this.basicIdValidate = "";
    this.payperviewValidate = "";
    this.ppvDetails="";
    this.packDetails = "";
    this.cartList.forEach((element) => {
      if (element.pType == "Pay Per View") {
        this.payperviewValidate = this.payperviewValidate + element.id + ",";
        this.ppvDetails=this.ppvDetails+(element.id+"~"+element.period+"~"+
        +element.directPrice+"~"+(element.directPrice*element.period)+"~"+element.totalTax)+"~"+element.deviceIds+"_"
      } else {
        this.basicIdValidate = this.basicIdValidate + element.id + ",";
        this.packDetails=this.packDetails+(element.id+"~"+element.period+
        "~"+element.directPrice+"~"+(element.directPrice*element.period)+"~"+element.totalTax)+"~"+element.deviceIds+"_"
      }
    });
    let data = {
      userId: this.userId,
      basicIds: this.basicIdValidate ? this.basicIdValidate.slice(0, -1) : "",
      payperView: this.payperviewValidate
        ? this.payperviewValidate.slice(0, -1)
        : "",
    };
    this.remoteapi
      .postExecuteAPI(
        2,
        environment.apiUrl + this.API.VALIDATE_PACKAGE_DETAILS,
        data
      )
      .subscribe((res) => {
        let respMsg = "";
        this.loaderShowHide(false);
        if (res.response) {
          res.response.forEach((element) => {
            respMsg = respMsg + element;
          });
        }
        if (res.responseCode == "SC101") {
          res.responseMessage
            ? (respMsg = respMsg + "  " + res.responseMessage)
            : respMsg;

          Swal.fire({
            title: respMsg,
            showConfirmButton: true,
            confirmButtonText: "Proceed",
            showCancelButton: true,
            cancelButtonText: "Cancel",
          }).then((willProceed) => {
            if (willProceed.value) {
              this.proceedPayment();
            }
          });
        } else if (res.responseCode == "FC101") {
          res.responseMessage
            ? (respMsg = respMsg + "  " + res.responseMessage)
            : respMsg;

          Swal.fire({
            title: respMsg,
          });
        } else {
          this.notify.clear();
          this.notify.error("Something went wrong");
        }
      });
  }




  clearCart() {
    this.cartList = [];
    this.packageList = [];
    this.selectedPackageType = "";
    this.deviceList = [];
    this.selectedPackage = "";
    this.selectedDevice = "";
    this.subscriberId = "";
    this.clearTaxDetails();
   // this.firstName = "";
   // this.userId = "";
  //  this.taxDetails = [];
  //  this.subscriptionPlanDetails = {};
   // this.packageList = [];
    this.loaderShow = false;
    this.totalAmount = 0;
    this.grandTotalAmount = 0;
    //this.totalTaxPer = 0;
    this.basicIdValidate = "";
    this.payperviewValidate = "";

    this.selectedPeriod = "";
    this.selectedDeviceList=[];
   // this.verifiedOnce = 0;
    //this.stepper.reset();
  }



  paymentSuccess() {
   // alert(123);
   // this.stepper.next();
   this.clearCart();
   this.getSubscriptionDetails();
   this.notify.clear();
   this.notify.success("Package has been Activated Successfully");
  }

  proceedPayment() {
    this.loaderShowHide(true);
    this.taxPrice = "";
    this.taxDetails.forEach((element) => {
      this.taxPrice = this.taxPrice + element.taxtot + ",";
    });

    this.RAZORPAY_OPTIONS.amount = (
      Number(parseFloat(this.grandTotalAmount).toFixed(2)) * 100
    ).toString();
    let data = {
      userId: this.userId,
      taxPrice: this.taxPrice.slice(0, -1),
      basicIds: this.packDetails,
      payperView: this.ppvDetails,
      totalPrice: parseFloat(this.grandTotalAmount).toFixed(2),
      currency: "INR",
      name:this.firstName,
    };

    this.remoteapi
      .postExecuteAPI(
        0,
        environment.apiUrl + this.API.CREATE_RAZOR_PAY_ORDER,
        data
      )
      .subscribe((result) => {
        this.loaderShowHide(false);
        if (result.responseCode === "SC101") {
          // window.location.href = "https://staging.bsnl.in/myportal/processcsoftpayrequest?"+result.response;
          window.location.href = "https://portal.bsnl.in/myportal/processcsoftpayrequest?"+result.response;
          // this.RAZORPAY_OPTIONS.order_id = result.response;
          // // binding this object to both success and dismiss handler
          // this.RAZORPAY_OPTIONS["handler"] = this.razorPaySuccessHandler.bind(
          //   this
          // );
          // let razorpay = new Razorpay(this.RAZORPAY_OPTIONS);
          // razorpay.open();
        } else if (result.responseCode == "FC101") {
          this.ngZone.run(() => {
            Swal.fire({
              title: result.responseMessage,
            });
          });
        }
      });
  }
  public razorPaySuccessHandler(response) {
    this.loaderShowHide(true);
    let data = {
      price: parseFloat(this.grandTotalAmount).toFixed(2),
      orderId: response.razorpay_order_id,
      paymentId: response.razorpay_payment_id,
      signature: response.razorpay_signature,
      userId: this.userId,
      basicIds: this.packDetails,
      payperView: this.ppvDetails,
      tax: this.taxPrice.slice(0, -1),
    };
    this.remoteapi
      .postExecuteAPI(0, environment.apiUrl + this.API.VALIDATE_RAZORPAY, data)
      .subscribe((result) => {
        this.loaderShowHide(false);
        if (result.responseCode == "SC101") {
          this.ngZone.run(() => {
            this.paymentSuccess();
          });
        } else if (result.responseCode == "FC101") {
          this.ngZone.run(() => {
            Swal.fire({
              title: result.responseMessage,
            });
          });
        }
      });
  }

  clearTaxDetails(){
    this.totalTaxPer = 0;
    this.taxDetails.forEach((element) => {
      element.taxtot=0;
      this.totalTaxPer = this.totalTaxPer + element.percentage;
    });
  //  alert("123____"+this.totalTaxPer);
  }

  clearAll() {
    this.cartList = [];
    this.packageList = [];
    this.selectedPackageType = "";
    this.deviceList = [];
    this.selectedPackage = "";
    this.selectedDevice = "";
    this.subscriberId = "";
    this.firstName = "";
    this.userId = "";
    this.clearTaxDetails();
  //  this.taxDetails = [];
    this.subscriptionPlanDetails = {};
    this.packageList = [];
    this.loaderShow = false;
    this.totalAmount = 0;
    this.grandTotalAmount = 0;
    //this.totalTaxPer = 0;
    this.basicIdValidate = "";
    this.payperviewValidate = "";
    this.verifiedOnce = 0;
    this.selectedPeriod = "";
    this.selectedDeviceList=[];
    this.ftaAdded = false;
    this.stepper.reset();
  }
  viewChannelList(){
  //   const dialogConfig = new MatDialogConfig();
  //   dialogConfig.data = {
  //     packageId : this.selectedPackage.packId
  // };
    console.log("coming")
    console.log(this.selectedPackage);
    debugger
    if(this.selectedPackage.devicePriceDetails == undefined) {
      this.notify.info("PPV Package - Selected channel will be available");
    } else if(this.selectedPackage&&this.selectedPackage.packId!=undefined){
      this.packageId = this.selectedPackage.packId
    this.dialog.open(ChannelListComponent,{
       width: "500px",
       panelClass: 'channel-list-wrap',
       data: {  defaultValue: this.packageId }
    });
  }else{
    this.notify.clear();
    this.notify.error("Select Package");
  }

  }

  verifyOTP(otp){
    if(otp!=null){
      let data ={
        userId:this.userId,
        otp:otp
      };
      this.remoteapi
      .postURLEncodedExecuteAPI(
        environment.apiUrl + this.API.VERIFY_OTP,data
    )      .subscribe((res) => {
      this.loaderShowHide(false);
      if (res.statusCode == 200) {
        this.valid=true
        this.getSubscriptionDetails();
      }else if(res.statusCode == 500){
        this.notify.clear();
        this.notify.error(res.response);
      }
      else {
        this.notify.clear();
        this.notify.error("Invalid OTP");
      }
    });
    console.log(otp)
    }else{
      this.notify.clear();
      this.notify.error("Please enter OTP");
    }
  }



  getSubscriptionDetails(){
    let data={
      userId:this.userId,
      packageStatus:1
    };
    this.remoteapi
      .postExecuteAPI(0,
        environment.apiUrl + this.API.GET_USER_SUBSCRIPTION_DETAILS,data
    )      .subscribe((res) => {
      this.loaderShowHide(false);
      if (res.responseCode == "SC101") {
        this.activesubscription=true;
        this.prebooksubscription=true;
        this.subscriptionhistory=true;
        if(res.response.activeSubscription.length>0){
         this.activesubscription=false;
        }
        if(res.response.prebookSubscription.length>0){
          this.prebooksubscription=false;
          }
        if(res.response.subscriptionHistory.length>0){
         this.subscriptionhistory=false;
        }
        this.subscriptionActive = res.response.activeSubscription;
        this.subscriptionPrebook =res.response.prebookSubscription;
        this.subscriptionHistory =res.response.subscriptionHistory;
        console.log(res.response.activeSubscription)
      } else {
        this.notify.clear();
        this.notify.error("Something went wrong");
      }
    });
  }

  sendOTPToMobileNumber(){
    console.log("called function sendOTPToMobileNumber")

    this.getSubscriptionDetails();

    let data={
      subUserId:this.subscriberId.trim(),
      userId:this.userId,
    };
    this.remoteapi
      .postURLEncodedExecuteAPI(
        environment.apiUrl + this.API.SEND_OTP,data
    )      .subscribe((res) => {
      console.log("send otp response is "+ res);
    });
  }

  onChange(event: MatTabChangeEvent) {
    const tab = event.tab.textLabel;
    console.log(tab);
    console.log(this.flag);
    if(tab==="Subscription History")
     {
       if(this.flag==1){
       console.log("function want to implement");
       let data={
        subscriberId:this.subscriberId,
        userId:this.userId,
      };
      this.remoteapi
      .postURLEncodedExecuteAPI(
        environment.apiUrl + this.API.SEND_OTP,data
    )      .subscribe((res) => {
      console.log("send otp response is "+ res);
      if (res.statusCode == 200) {
        if(res.response.status==1){
        this.notify.clear();
        this.notify.success("OTP has been sent to mobile");
        }else if(res.response.status==0){
          this.activesubscription=false;
          this.notify.clear();
          this.notify.error("New otp can be sent only after "+res.response.minutes+ " minutes");
        } else if(res.response.status==-1){
          this.activesubscription=false;
          this.notify.clear();
          this.notify.error(res.response.message);
        }
      } else {
        this.notify.clear();
        this.notify.error("Something went wrong");
      }
    });
       this.flag=2;
       }else{
         console.log("flagged")
         console.log("flag value change"+this.flag);
       }
      }
  }


}
